<div class="container-fluid">
  <div class="mega_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-8 col-lg-8">
          <div class="mega_header-information__sub-header">Confirmation</div>
        </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4">
          <button
            class="button fm-secondary-button float-end"
            [disabled]="exportPDFButtonClicked"
            (click)="exportMultiMegaPDFConfirmationDetails()"
          >
            <i class="fa fa-file-pdf-o button-icon"></i>EXPORT PDF
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="line-break"></div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7 col-lg-7 confirmation-info-header">
        <p>
          Your pool commitments have been submitted to Fannie Mae. Confirmation emails have been
          sent to {{ multiMegaCommitResponse?.dealerEmail }} and the Structured Transactions Group
          at Fannie Mae.
        </p>
      </div>
      <div class="col-12 col-sm-12 col-md-5 col-lg-5 pr-0">
        <div class="float-end">
          <p><span class="fw-bold">Dealer: </span> {{ multiMegaCommitResponse.orgName }}</p>
          <p>
            <span class="fw-bold">Dealer Contact: </span>{{ multiMegaCommitResponse.dealerName }}
          </p>
          <p>
            <span class="fw-bold">Committed Date: </span>
            {{ multiMegaCommitResponse.commitedDate | date: 'MM/dd/yyyy' }}
          </p>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
      <div class="line-break"></div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 confirmation-mega-type-header">
        <div>Pool Type</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7 col-lg-7 pl-0">
        <ng-container *ngIf="multiMegaCommitResponse.megaType === 'SFFIXMEGA'">
          <div class="fw-bold-and-size">Single Family Fixed Rate</div>
        </ng-container>
        <ng-container *ngIf="multiMegaCommitResponse.megaType === 'SFARMMEGA'">
          <div class="fw-bold-and-size">Single Family ARM</div>
        </ng-container>
        <ng-container *ngIf="multiMegaCommitResponse.megaType === 'MFFIXMEGA'">
          <div class="fw-bold-and-size">Multi Family Fixed Rate</div>
        </ng-container>
        <ng-container *ngIf="multiMegaCommitResponse.megaType === 'MFARMMEGA'">
          <div class="fw-bold-and-size">Multi Family ARM</div>
        </ng-container>
      </div>

      <div class="col-12 col-sm-12 col-md-5 col-lg-5 pr-0">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-8 col-lg-8 mt-3">
            <span class="float-end"
              ><span class="fw-bold">Export:</span
              ><a class="export-links float-end" (click)="exportMultiMegaExcelConfirmationDetails()"
                >Excel</a
              ></span
            >
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 pr-0 pl-0">
            <span class="float-end">
              <span class="fw-bold-and-size total-mega-count"
                >Total Pools: {{ committedMegaList.length }}</span
              >
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 pt-10 pd-20 committed-new-megalist-table">
        <div class="fm-cdx-table">
          <table class="fm-cdx-table__static">
            <thead>
              <tr class="th_row">
                <th class="th_column">POOL #</th>
                <th class="th_column width-25">CUSIP</th>
                <th class="th_column width-25">PREFIX</th>
                <ng-container *ngIf="multiMegaCommitResponse.megaType === 'SFFIXMEGA'">
                  <th class="th_column th_column--is-numeric">COUPON</th>
                </ng-container>
                <ng-container *ngIf="multiMegaCommitResponse.megaType === 'MFFIXMEGA'">
                  <th class="th_column th_column--is-numeric">HIGH COUPON</th>
                </ng-container>
                <ng-container *ngIf="multiMegaCommitResponse.megaType === 'MFFIXMEGA'">
                  <th class="th_column th_column--is-numeric">LOW COUPON</th>
                </ng-container>
                <ng-container
                  *ngIf="
                    multiMegaCommitResponse.megaType === 'SFARMMEGA' ||
                    multiMegaCommitResponse.megaType === 'MFARMMEGA'
                  "
                >
                  <th class="th_column">SUBTYPE</th>
                </ng-container>
                <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                <th class="th_column pl-85">SETTLEMENT</th>
                <th class="th_column th_column--is-numeric">FEE</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="td_row commit-mega-table-header"
                *ngFor="let committedMega of committedMegaList; trackBy: trackByIdentity"
              >
                <td class="td_cell">
                  <span id="megaNumber">{{
                    committedMega?.poolNumber ? committedMega?.poolNumber : ''
                  }}</span>
                </td>
                <td class="td_cell">
                  <span id="cusip">{{ committedMega?.cusip ? committedMega?.cusip : '' }}</span>
                </td>
                <td class="td_cell">
                  <span id="prefix">{{ committedMega?.prefix ? committedMega?.prefix : '' }}</span>
                </td>
                <ng-container *ngIf="multiMegaCommitResponse.megaType === 'SFFIXMEGA'">
                  <td class="td_cell td_cell--is-numeric">
                    <span id="sfFixedCoupon">{{
                      committedMega?.sfFixedCoupon | number: '1.3-3'
                    }}</span>
                  </td>
                </ng-container>
                <ng-container *ngIf="multiMegaCommitResponse.megaType === 'MFFIXMEGA'">
                  <td class="td_cell td_cell--is-numeric">
                    <span id="mfHighCoupon">{{
                      committedMega?.mfHighCoupon | number: '1.3-3'
                    }}</span>
                  </td>
                </ng-container>
                <ng-container *ngIf="multiMegaCommitResponse.megaType === 'MFFIXMEGA'">
                  <td class="td_cell td_cell--is-numeric">
                    <span id="mfLowCoupon">{{ committedMega?.mfLowCoupon | number: '1.3-3' }}</span>
                  </td>
                </ng-container>
                <ng-container
                  *ngIf="
                    multiMegaCommitResponse.megaType === 'SFARMMEGA' ||
                    multiMegaCommitResponse.megaType === 'MFARMMEGA'
                  "
                >
                  <td class="td_cell">
                    <span id="sfARMSubType">{{ committedMega?.sfARMSubType }}</span>
                  </td>
                </ng-container>
                <td class="td_cell td_cell--is-numeric">
                  <span id="tradeAmount">{{
                    committedMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                  }}</span>
                </td>
                <ng-container *ngIf="!committedMega.earlyCloseFlag">
                  <td class="td_cell">
                    <span id="tradeSettlementDate">{{
                      committedMega?.tradeSettlementDate | date: 'MM/dd/yyyy'
                    }}</span>
                  </td>
                </ng-container>
                <ng-container *ngIf="committedMega.earlyCloseFlag">
                  <td class="td_cell">
                    <span id="tradeSettlementDate-earlyClose"
                      >{{ committedMega?.tradeSettlementDate | date: 'MM/dd/yyyy'
                      }}<i class="fa fa-asterisk legend-icon pl-3"></i
                    ></span>
                  </td>
                </ng-container>
                <ng-container *ngIf="committedMega?.newFeeDollars !== null">
                  <td class="td_cell td_cell--is-numeric">
                    <ng-container *ngIf="needsDisclaimer(committedMega?.prefix); else noDisclaimer">
                      <span id="newFeeDollars" class="fw-bold fee-warning-red"
                        >{{ committedMega?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                      </span>
                    </ng-container>
                    <ng-template #noDisclaimer>
                      <span id="newFeeDollars" class="fw-bold"
                        >{{ committedMega?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                      </span>
                    </ng-template>
                  </td>
                </ng-container>
                <ng-container *ngIf="committedMega?.newFeeTicks !== null">
                  <td class="td_cell td_cell--is-numeric">
                    <ng-container
                      *ngIf="needsDisclaimer(committedMega?.prefix); else noTickDisclaimer"
                    >
                      <span id="newFeeTicks" class="fw-bold fee-warning-red"
                        >{{ committedMega?.newFeeTicks | number: '1.3-3' }}/32*
                      </span>
                    </ng-container>
                    <ng-template #noTickDisclaimer>
                      <span id="newFeeTicks" class="fw-bold"
                        >{{ committedMega?.newFeeTicks | number: '1.3-3' }}/32
                      </span>
                    </ng-template>
                  </td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="fee-warning-red">{{ disclaimerMessage }}</p>
        <br />
      </div>
    </div>
    <!--Market Early Close Date section-->
    <div class="row" *ngIf="showEarlyCloseLegend">
      <div class="col-12">
        <p>
          <i class="fa fa-asterisk legend-icon"></i>Market closes early on this day. Please be sure
          someone from the Structured Transactions team is available to complete this transaction.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 margin-top-10 visible-md-12">
        <button
          class="button fm-primary-button button--margin-right"
          *ngIf="showSubmitPoolInfo"
          (click)="allowUpload()"
        >
          Upload Collateral Information
        </button>
        <button class="button fm-secondary-button" (click)="navigatePageToCommittedListing()">
          View Committed Pools
        </button>
      </div>
    </div>
    <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12 col-sm-12">
        <button class="button fm-primary-button button--margin-right col-12">Upload Collateral Information</button>
        <button class="button fm-secondary-button col-12" (click)="navigatePageToCommittedListing()">View Committed Pools</button>
    </div> -->

    <!--Mega pricing updates section-->
    <section class="mega-pricing-updates-section pt-20" *ngIf="megaPricingSummaryList.length > 0">
      <div class="row">
        <div class="col-12 col-md-5 pl-0">
          <div class="fw-bold">
            Pricing Summary -
            <span class="mega-pricing-pricing-month" *ngIf="!isMayPricingMonth"
              >{{ multiMegaCommitResponse?.pricingMonth | date: 'MMM' }}.
              {{ multiMegaCommitResponse?.pricingMonth | date: 'yyyy' }}</span
            >
            <span class="mega-pricing-pricing-month" *ngIf="isMayPricingMonth"
              >{{ multiMegaCommitResponse?.pricingMonth | date: 'MMM' }}
              {{ multiMegaCommitResponse?.pricingMonth | date: 'yyyy' }}</span
            >
          </div>
        </div>
        <div class="col-12 col-md-7 visible-md-7 pr-0">
          <div class="row">
            <div class="col-12 col-md-9">
              <span class="fw-bold total-volume-position"
                >Total Volume:
                <span>{{
                  multiMegaCommitResponse?.monthlyVolume | currency: 'USD' : 'symbol' : '1.0'
                }}</span></span
              >
            </div>
            <div class="col-12 col-md-3 pr-0">
              <span class="float-end">
                <span class="fw-bold total-mega-pricing-count"
                  >Total Pools: {{ megaPricingSummaryList.length }}</span
                >
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12 pl-0">
          <div class="col-12 col-sm-12 col-md-9 col-lg-9 pl-0">
            <span class="fw-bold">Total Volume: <span>{{ multiMegaCommitResponse?.monthlyVolume | currency:'USD':'symbol':'1.0' }}</span></span>
          </div>
          <div class="col-12 col-sm-12 col-md-3 col-lg-3 pr-0 pl-0">
            <span class="fw-bold total-mega-pricing-count">Total Pools: {{ megaPricingSummaryList.length}}</span>
          </div>
        </div> -->
      </div>
      <div class="row" *ngIf="megaPricingSummaryList !== null">
        <div class="col-12 mega-pricing-update-table pt-10 px-0">
          <div class="fm-cdx-table">
            <table class="fm-cdx-table__static">
              <thead>
                <tr class="th_row">
                  <th class="th_column">POOL #</th>
                  <th class="th_column width-25">CUSIP</th>
                  <th class="th_column">PREFIX</th>
                  <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                  <th class="th_column pl-85">SETTLEMENT</th>
                  <th class="th_column th_column--is-numeric">FEE</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="multiMegaCommitResponse.megaType === 'MFFIXMEGA'">
                  <tr
                    class="td_row commit-mega-table-header"
                    *ngFor="let megaPricing of megaPricingSummaryList; trackBy: trackByIdentity"
                  >
                    <td class="td_cell width-poolNumber-MFFIX">
                      <span id="pricing-update-mega-number-MFFIX">{{
                        megaPricing?.poolNumber
                      }}</span>
                    </td>
                    <td class="td_cell width-cusip-MFFIX">
                      <span id="pricing-update-cusip-MFFIX">{{ megaPricing?.cusip }}</span>
                    </td>
                    <td class="td_cell width-prefix-MFFIX">
                      <span id="pricing-update-mf-prefixCode">{{ megaPricing?.prefix }}</span>
                    </td>
                    <td class="td_cell td_cell--is-numeric width-tradeAmount-MFFIX">
                      <span id="pricing-update-trade-amount-MFFIX">{{
                        megaPricing?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                      }}</span>
                    </td>
                    <ng-container *ngIf="!megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85 width-settelmentDate-MFFIX">
                        <span id="pricing-update-settlementDate-MFFIX">{{
                          megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                        }}</span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85 width-settelmentDate-MFFIX">
                        <span id="pricing-update-settlementDate-MFFIX-earlyClose"
                          >{{ megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                          }}<i class="fa fa-asterisk legend-icon pl-3"></i
                        ></span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.newFeeDollars !== null">
                      <td class="td_cell td_cell--is-numeric">
                        <span id="pricingFee-newFeeDollars-MFFIX" class="fw-bold"
                          >{{ megaPricing?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                        </span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.newFeeTicks !== null">
                      <td class="td_cell td_cell--is-numeric">
                        <span id="pricingFee-newFeeTicks-MFFIX" class="fw-bold"
                          >{{ megaPricing?.newFeeTicks | number: '1.3-3' }}/32
                        </span>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
                <ng-container *ngIf="multiMegaCommitResponse.megaType !== 'MFFIXMEGA'">
                  <tr
                    class="td_row commit-mega-table-header"
                    *ngFor="let megaPricing of megaPricingSummaryList; trackBy: trackByIdentity"
                  >
                    <td class="td_cell width-poolNumber">
                      <span id="pricing-update-mega-number">{{ megaPricing?.poolNumber }}</span>
                    </td>
                    <td class="td_cell width-cusip">
                      <span id="pricing-update-cusip">{{ megaPricing?.cusip }}</span>
                    </td>
                    <td class="td_cell width-prefix">
                      <span id="pricing-update-prefixCode">{{ megaPricing?.prefix }}</span>
                    </td>
                    <td class="td_cell td_cell--is-numeric width-tradeAmount">
                      <span id="pricing-update-trade-amount">{{
                        megaPricing?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                      }}</span>
                    </td>
                    <ng-container *ngIf="!megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85 width-settelmentDate">
                        <span id="pricing-update-settlementDate">{{
                          megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                        }}</span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85 width-settelmentDate">
                        <span id="pricing-update-settlementDate-earlyClose"
                          >{{ megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                          }}<i class="fa fa-asterisk legend-icon pl-3"></i
                        ></span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.newFeeDollars !== null">
                      <td class="td_cell td_cell--is-numeric">
                        <ng-container
                          *ngIf="
                            summaryNeedsDisclaimer(megaPricing?.prefix);
                            else noSummaryDisclaimer
                          "
                        >
                          <span id="pricingFee-newFeeDollars" class="fw-bold fee-warning-red">
                            {{ megaPricing?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                          </span>
                        </ng-container>
                        <ng-template #noSummaryDisclaimer>
                          <span id="pricingFee-newFeeDollars" class="fw-bold">
                            {{ megaPricing?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                          </span>
                        </ng-template>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing?.newFeeTicks !== null">
                      <td class="td_cell td_cell--is-numeric">
                        <span id="pricingFee-newFeeTicks" class="fw-bold"
                          >{{ megaPricing?.newFeeTicks | number: '1.3-3' }}/32
                        </span>
                      </td>
                    </ng-container>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-12 pt-20">
        <p class="fee-warning-red">
          {{ summaryDisclaimer }}
        </p>
      </div>
    </div>
    <div class="row" *ngIf="showEarlyCloseLegendPricingSummary">
      <div class="col-12 pt-20">
        <p>
          <i class="fa fa-asterisk legend-icon"></i>Market closes early on this day. Please be sure
          someone from the Structured Transactions team is available to complete this transaction.
        </p>
      </div>
    </div>
  </div>
</div>
